import React from "react"
import { useTranslation } from "react-i18next"

import { scale } from "utils"

const PloptfcCustomText = (props) => {
  const { templateType, text, printerWidth } = props

  const i18n = useTranslation()[1]

  const dir = i18n.dir(i18n.language)

  const styles =
    templateType === "thermal"
      ? stylesThermal(printerWidth, dir)
      : stylesOthers(dir)

  return (
    <div style={styles["container"]}>
      <div style={styles["text"]}>
        {text}
      </div>
    </div>
  )
}

const stylesThermal = (printerWidth) => ({
  container: {
    fontSize: scale("19px", printerWidth),
    paddingTop: scale("10px")
  },

  text: {
    fontWeight: "bold",
    textAlign: "center"
  }
})

const stylesOthers = () => ({
  container: {
    marginRight: "8px",
    fontSize: "11px",
    paddingTop: "4px"
  },

  text: {
    fontWeight: "bold",
    textAlign: "center"
  }
})

export default PloptfcCustomText